{
  "exportGeoJson": {
    "exportLayersInfo": "Ausgewählte Ebenen werden exportiert. Wir informieren Sie, wenn es fertig ist"
  },
  "importGeoJson": {
    "invalidGeoJson": {
      "title": "Ungültiger Dateityp",
      "message": "Die Datei, die Sie hochgeladen haben, ist ungültig. Bitte laden Sie eine gültige GeoJSON-, JSON-, GPX- oder KML/KMZ-Datei hoch."
    },
    "somethingWentWrong": {
      "title": "Etwas ist schief gelaufen",
      "message": "Der Dateityp, den Sie hochgeladen haben, ist ungültig. Bitte laden Sie eine gültige GeoJSON-, JSON-, GPX- oder KML/KMZ-Datei hoch."
    },
    "fileTooLarge": {
      "title": "Die Datei ist zu groß",
      "message": "Die Datei, die Sie hochladen möchten, ist zu groß. Die maximale Dateigröße ist {{ size }}"
    },
    "invalidGeometry": {
      "title": "Ungültige Geometrie",
      "message": "Der Layer-Typ, den Sie hochladen möchten, hat eine ungültige Geometrie."
    },
    "invalidLayerType": {
      "title": "Inkompatibler Ebenentyp",
      "message": "Sie versuchen, eine {{ importType }} -Ebene auf eine {{ layerType }} -Ebene hochzuladen."
    },
    "invalidCoordinateSystem": {
      "title": "Das Koordinatensystem wird nicht unterstützt",
      "message": "Das Koordinatensystem wird nicht unterstützt, bitte verwenden Sie {{ coordinateSystem }}"
    },
    "reuploadGeoJson": "Die unterstützte Dateierweiterung ist {{ fileExtensions }} und die maximale Dateigröße beträgt bis zu {{ size }}",
    "mappedAttributeDescription": "Wählen Sie Eigenschaften aus der Datei aus, die als Ebenenattribute importiert werden sollen (optional).",
    "layerAttribute": "Ebenenattribut",
    "type": "Typ",
    "fieldToImport": "Zu importierendes Feld",
    "overwriteExisting": "Bestehendes überschreiben",
    "importLayer": "Ebene importieren"
  },
  "importKML": {
    "invalidKML": {
      "title": "Ungültige KML-Daten",
      "message": "Die KML-Daten sind ungültig. Bitte überprüfen Sie Ihre Quelldatei und versuchen Sie es erneut."
    },
    "folderSelectLabel": "Standardebenen für den Import",
    "allFolders": "Alle Ebenen"
  },
  "importGpx": {
    "invalidGpx": {
      "title": "Ungültige GPX-Daten",
      "message": "Die GPX-Daten sind ungültig. Bitte überprüfen Sie Ihre Quelldatei und versuchen Sie es erneut."
    },
    "import_track": "Titel importieren",
    "import_route": "Route importieren"
  },
  "analysis_drawing_tooltips": {
    "title": "Analyse-Tools",
    "enter_edit_mode": "Verwenden Sie die Zeichenwerkzeuge, um Kartenobjekte auszuwählen und Bereiche, Linien usw. zu analysieren.",
    "enter_edit_mode_link": "Klicken Sie hier, um mehr über dieses Tool zu erfahren"
  },
  "dataTableGrouping": {
    "checkbox": "Daten gruppieren"
  },
  "assets": {
    "edit": "Ausgewähltes Asset bearbeiten",
    "delete": "Ausgewähltes Asset löschen",
    "uploadAsset": "Asset hochladen",
    "deleteTitleIcon": "Symbol löschen",
    "deleteDescriptionIcon": "Möchten Sie dieses Symbol wirklich löschen?",
    "deleteTitleModel": "Modell löschen",
    "deleteDescriptionModel": "Möchten Sie diesen Modus wirklich löschen?"
  },
  "toolbarButtonTooltips": {
    "route": "Routengenerator"
  },
  "routeGenerator": {
    "routeGenerator": "Routengenerator",
    "distance": "Entfernung",
    "travelTime": "Zeit der Reise",
    "addStop": "Stopp hinzufügen",
    "addRoute": "Neue Route",
    "removeStop": "Stopp entfernen",
    "search": "Suchen oder klicken Sie auf die Karte"
  },
  "exports": {
    "remarks": {
      "title": "Benutzerdefinierte Anmerkungen",
      "placeholder": "Fügen Sie hier benutzerdefinierte Anmerkungen ein",
      "error": "Die Anmerkungen sind zu lang"
    }
  },
  "styles": {
    "modelOffset": "Modell-Offset"
  },
  "attributes": {
    "imageDescription": "Sie können nur 1 Bild pro Attribut hochladen. Sie können Ihre Auswahl unten ersetzen.",
    "imageTitle": "Laden Sie das Bild zum Attribut hoch",
    "noImageSelected": "Keine Datei ausgewählt"
  },
  "layerTemplates": {
    "chosenForYou": "Für dich ausgewählt"
  },
  "contextMenu": {
    "addAttributeMultipleLayers": "Fügen Sie allen ein Attribut hinzu"
  },
  "importLayers": {
    "folderOutsideMap": "Ein Ordner kann nicht von außerhalb einer Karte importiert werden"
  },
  "delete": {
    "multipleTitleMix": "Löschen Sie mehrere Elemente",
    "multipleDescriptionMix": "Beim Löschen einer Gruppe werden alle Ebenen und ihre Objekte gelöscht",
    "importLayerHint": "Die importierte Ebene wird nur aus der Karte entfernt und ist im ursprünglichen Plan enthalten",
    "multipleLayersTitle": "Löschen Sie mehrere Ebenen",
    "multipleLayersDescription": "Wenn Sie mehrere Ebenen löschen, werden auch alle darin enthaltenen Objekte gelöscht",
    "multipleImportLayersTitle": "Importierte Ebenen entfernen",
    "singleImportLayersTitle": "Importierte Ebene entfernen",
    "importLayersDescription": "Durch das Löschen der importierten Ebene werden nur die Objekte aus Ihrer Karte gelöscht. Sie können die Ebene jederzeit aus der verknüpften Karte importieren",
    "singleLayerTitle": "Löschen Sie eine Ebene",
    "singleLayerDescription": "Wenn Sie diese Ebene löschen, werden auch alle darin enthaltenen Objekte gelöscht"
  }
}